import moment from 'moment';
import { useEffect } from 'react';
import { useRecoilState } from 'recoil';
import roomsState from '../../../atoms/rooms';
import emitGetRooms from '../../../connector/emits/getRooms';
import './HomeRooms.scoped.scss';
import Room from "./Room";

function HomeChatting() {
  const [rooms] = useRecoilState(roomsState);

  useEffect(() => {
    emitGetRooms();
  }, []);

  const thumbnailUrlTailer = Math.floor(moment().unix() / 60);

  const sortedRooms = rooms.filter((room) => room.id !== '' && room.id !== 'square');
  sortedRooms.sort((a, b) => b.participants - a.participants);


  const onClickOpenWaitingRoomButton = () => {
    window.open(
      '/chatting-app/waiting-room', 
      'Waiting Room', 
      'width=940px,height=640px,status=no,scrollbars=no,toolbar=no'
    );
  };

  return (
    <div>
      <div className="home-rooms-fixed">
        <button onClick={onClickOpenWaitingRoomButton}>채팅대기실</button>
      </div>
      <div className="home-rooms-list">
        {sortedRooms.map((room, index) => {
          const thumbnailUrl = room.ownerDetail.hasThumbnail
          ? `/data/member_image/${room.owner.substring(0, 2)}/${room.owner}.gif?${thumbnailUrlTailer}`
          : '/img/profile.png';

          return (
            <Room 
              key={index}
              thumbnailUrl={thumbnailUrl}
              name={room.name}
              participants={room.participants}
              maxParticipants={room.maxParticipants}
              ownerLevel={room.ownerDetail.level}
              ownerName={room.ownerDetail.nickname}
              roomId={room.id}
              isSecret={room.isSecret}
            />
          )
        })}
      </div>
    </div>
  );
}

export default HomeChatting;